import {getArtworkPreviewInfo} from "@js/api/domain/artwork";

$(document).ready(function () {
    // Delegated handler — preview modal content is loaded dynamically via Ajax
    $(document).on('click', '.js-show-artwork-details', async function (e) {
        e.preventDefault();

        const itemArtworkID = $(this).data('itemartworkid');
        const brandArtworkID = $(this).data('brandartworkid');
        const previewArtworkID = itemArtworkID || brandArtworkID || null;

        if (!previewArtworkID) return;

        const isInsidePreviewModal = $(this).closest('#previewModal').length > 0;

        if (isInsidePreviewModal) {
            const $slideView = $('#artworkDetailsSlideView');
            if (!$slideView.length) return;
            const previewType = itemArtworkID ? 'item-artwork' : 'brand-artwork';


            const { data } = await getArtworkPreviewInfo(previewArtworkID, {
                previewType: previewType,
            });
            const artworkInfo = data;

            $slideView.find('.js-details-target-content').html(`
                <div class="artwork-details-slide-inner">
                    <h3>Artwork Details</h3>
                    <div class="art-details-img-frame">
                        <img class="image w-100" src="${artworkInfo.artworkImgUrl}" alt="" />
                    </div>
                    <hr />
                    <div class="art-info">
                        <span><b>Artwork:</b> ${artworkInfo.artworkName}</span><br>
                        <span><b>Category:</b> ${artworkInfo.artworkCategory}</span><br>
                        ${previewType === "item-artwork" ? `<span><b>Notes:</b> ${artworkInfo.artworkNotes}</span><br>` : ''}
                    </div>
                </div>
            `);

            $slideView.addClass('is-visible');
        } else {
            // boostrap 3 refuses to open programatically here when trigger and modal are loaded through ajax
            $(`.js-zoneArtworkDetailModal${previewArtworkID}-trigger`).click();
        }
    });

    // Back arrow closes the slide view
    $(document).on('click', '#artworkDetailsSlideView .js-back-arrow', function () {
        $('#artworkDetailsSlideView').removeClass('is-visible');
    });

    // Reset slide view when previewModal closes
    $('#previewModal').on('hidden.bs.modal', function () {
        $('#artworkDetailsSlideView')
            .removeClass('is-visible')
            .find('.js-details-target-content').empty();
    });
});
